import { render, staticRenderFns } from "./CallRatingPieChart.vue?vue&type=template&id=276aa1c1&"
import script from "./CallRatingPieChart.vue?vue&type=script&lang=js&"
export * from "./CallRatingPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports